import data from '@vp/visage/dist/docs.json'

export type PropsAutoGenType = {
  name: string
  raw?: string
  value?: {
    value: string
  }[]
}

export type PropsAutoGen = {
  defaultValue: null | {
    value: string
  }
  description: string
  name: string
  required: boolean
  type: PropsAutoGenType
}

export type ComponentPropsAutoGen = {
  file: string
  description: string
  displayName: string
  methods: []
  props: Record<string, PropsAutoGen>
}

export type AllProps = Record<string, ComponentPropsAutoGen>

export function getComponentProps(name: string): ComponentPropsAutoGen | null {
  return (data as AllProps)[name] || null
}
